var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk1764343430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 203.1 30",
    style: {
      enableBackground: "new 0 0 203.1 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.1,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 5.1818 35.8699)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.6,
    y: 7.1,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 18.7008 74.9988)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,30H57.8V0h30.1V30z M58.9,28.8h27.8V1.2H58.9V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,25.9H61.2V3.7H84V25.9z M62.4,24.8h20.4v-20H62.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 18.7232 90.0484)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.7,
    y: 7.1,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 76.5333 174.8804)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.8,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.1,30h-30.1V0h30.1V30z M174.1,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1,25.9h-22.7V3.7h22.7V25.9z M177.5,24.8H198v-20h-20.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -1.6146 8.6776)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8,
    y: 7.1,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 -10.3087 24.8818)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,25.9H3.4V3.7h22.7V25.9z M4.6,24.8H25v-20H4.6V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 15.35 76.5525)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 7.1,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 62.1305 150.0038)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,30h-30.1V0h30.1V30z M145.4,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,25.9h-22.7V3.7h22.7V25.9z M148.9,24.8h20.4v-20h-20.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.6,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.9444 62.9267)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.1,
    y: 7.1,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 47.5659 124.8662)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,30h-30.1V0h30.1V30z M116.4,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,25.9h-22.7V3.7h22.7V25.9z M119.9,24.8h20.4v-20h-20.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.5712 49.4307)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 7.1,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 33.168 99.9924)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,30H86.6V0h30.1V30z M87.8,28.8h27.8V1.2H87.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8,25.9H90V3.7h22.7V25.9z M91.2,24.8h20.4v-20H91.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.7911 22.3034)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 7.1,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 4.2367 50.0087)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,30H29V0h30.1V30z M30.1,28.8h27.8V1.2H30.1V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,25.9H32.4V3.7h22.7V25.9z M33.6,24.8H54v-20H33.6V24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk1764343430);
export default __webpack_public_path__ + "static/media/AK1_7_6434343_0.d936da520438e0dfbf3a37ef073d5d55.svg";
export { ForwardRef as ReactComponent };